<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="sourcingLineHeadInfo" class="form_border" :label-position="labelPosition" label-width="140px">
          <el-row type="flex" justify="left" style="margin-bottom:20px">
            <el-button size="mini" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
            <!--关闭-->
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('quoteByLine.sourcing.sourcingNo')" prop="sourcingNo">
                <el-input class="handle-input" v-model="sourcingLineHeadInfo.sourcingNo" clearable disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('quoteByLine.sourcing.subject')" prop="subject">
                <el-input class="handle-input" v-model="sourcingLineHeadInfo.subject" clearable disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('quoteByLine.sourcing.applyType')" prop="applyType">
                <el-input class="handle-input" v-model="sourcingLineHeadInfo.applyTypeI18n" clearable disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('quoteByLine.sourcing.quotationType')" prop="quotationType">
                <el-input class="handle-input" v-model="sourcingLineHeadInfo.quotationTypeI18n" clearable disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('common.createBy')" prop="createBy">
                <el-input class="handle-input" v-model="sourcingLineHeadInfo.createUserName" clearable disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('common.createDate')" prop="createDate">
                <el-date-picker value-format="yyyy-MM-dd" v-model="sourcingLineHeadInfo.createDate" type="date" clearable disabled style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('quoteByLine.sourcing.supplierCode')" prop="supplierCode">
                <el-input class="handle-input" v-model="sourcingLineHeadInfo.supplierCodes" clearable disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('quoteByLine.sourcing.applyNo')" prop="applyNo">
                <el-input class="handle-input" v-model="sourcingLineHeadInfo.applyNo" clearable disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-tabs v-model="activeName">
          <el-tab-pane label="线路报价明细" name="first">
            <ux-grid ref="SourcingLineData" :data="SourcingLineData" keep-source max-height="550" highlight-current-row show-overflow="tooltip">
              <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.itemNo')" field="itemSequence" min-width="120px"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.finalSupplier')" field="supplierName" min-width="150"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.pickupPoint')" field="pickupPoint" min-width="90"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.dc')" field="dcName" min-width="130"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.temperature')" field="temperatureI18n" min-width="100"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.transportaionMethod')" field="transportaionMethodI18n" min-width="100"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.effectiveBeginDate')" field="effectiveBeginDate" min-width="140">
                <template v-slot="scope">
                  {{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}
                </template>
              </ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.price')" field="price" min-width="140"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.currentPrice')" field="formalPrice" min-width="130px"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.currencyCode')" field="currencyCode" min-width="100"></ux-table-column>
              <ux-table-column align="center" sortable resizable title="Leadtime" field="leadTime" min-width="130px"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('apply.estimatedAnnualTotalCost')" field="estimatedAnnualFee" min-width="130px"></ux-table-column>
              <ux-table-column align="center" sortable resizable title="线路类型" field="lineType" min-width="100"></ux-table-column>
              <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.remarks')" field="remarks" min-width="100"></ux-table-column>
            </ux-grid>
          </el-tab-pane>
          <el-tab-pane :label="$t('common.approvalLog')" name="log">
            <el-table :data="auditLog" border highlight-current-row class="table">
              <el-table-column sortable prop="operatorName" align="center" :label="$t('common.OperatorName') "></el-table-column>
              <el-table-column sortable prop="createDate" align="center" :label="$t('common.OperationTime') ">
                <template slot-scope="scope">
                  {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}
                </template>
              </el-table-column>
              <el-table-column sortable prop="action" align="center" :label="$t('common.PedagogicalOperation') "></el-table-column>
              <el-table-column sortable prop="comments" align="center" :label="$t('common.remarks') "></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>

      </div>
    </div>
  </div>
</template>

<script>
import { search } from "../../../api/line/sourcing";
import router from '../../../router';

export default {
  name: 'sourcingDetail',

  data() {
    return {
      activeName: 'first',
      labelPosition: 'right',
      SourcingLineData: [],
      sourcingLineHeadInfo: {},
      queryCondition: {
        pageSize: 0,
        pageNum: 1,
        sourcingNo: ''
      },
      auditLog: [],
    }
  },
  watch: {

  },

  mounted() {
    this.queryCondition.sourcingNo = this.$route.query.sourcingNo;
    this.querySourcingLine();
  },

  methods: {
    querySourcingLine() {
      search(this.queryCondition).then((res) => {
        this.SourcingLineData = res.resultData;
        this.auditLog = res.logs;
        this.sourcingLineHeadInfo = this.SourcingLineData[0];
        this.sourcingLineHeadInfo.createDate = this.sourcingLineHeadInfo.createDate;
        this.$refs.SourcingLineData.reloadData(res.resultData)
      })
    },

    historyBack: function () {
      /*                router.replace({
                          path: '/sourcing'
                      });*/
      this.$router.go(-1);
    },

  },
}



</script>
<style scoped>
.handle-input {
  width: 95%;
}
.query-btn-row {
  width: 30%;
  float: right;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}
.dialog-input {
  width: 40%;
}
</style>
